import Icon from "@/wmCompoments/Icon";
import React, { useRef, useState } from "react";
import styles from './index.module.scss'
import { useFeedbackList } from "./hooks/api";
import PaginationTo from "../betOrderRecords/compoments/paginationTo";
import { useNavigate } from "react-router";
import Detail from "./compoments/detail";
import SpinLoading from "@/wmCompoments/spinLoading";
import LoadingUI from "@/compoments/loadingUI";
import Spin from "@/wmCompoments/spin";


const PAGE_SIZE = 6;

const MyFeedback = () => {

    const [visible, setVisible] = useState(false)
    const warpperRef = useRef<any>(null)

    const [params, setParams] = useState({
        pageNum: 1,
        pageSize: PAGE_SIZE
    })

    const navigate = useNavigate()
    const [currentIndex, setCurrentIndex] = useState(-1)
    const { data, isLoading , mutate } = useFeedbackList(params)

    const { totalRecord } = data ?? {}

    const handleBack = () => {
        navigate('/mine/feedback')
    }

    const handleDetail = (i) => {
        setVisible(true)
        setCurrentIndex(i)
    }

    return <div className={styles.warpper} ref={warpperRef}>

        <div className={styles.title}>
            <div onClick={handleBack}>
                <Icon name={'icon-general-arrow-line-left'} />
            </div>

            <span>我的反馈</span>
        </div>

        <div className={styles.listWarpper}>


            {
                data?.list?.map?.((v, index) => {
                    return <div key={index} className={styles.item}
                        onClick={() => handleDetail(index)}
                    >
                        <div className={styles.imgWarpper}>
                            <img src={v.iconUrl} />
                        </div>
                        <div className={styles.contentWarpper}>
                            <div>
                                {v.title}
                            </div>
                            <div>
                                {v.content}
                            </div>
                        </div>
                        <div className={styles.time}>
                            {v.createdAt}
                        </div>
                    </div>
                })
            }
            {
                isLoading && <div className={styles.loading} >
                    <Spin />
                </div>
            }
            {
                !isLoading && !data?.list?.length && <LoadingUI />
            }
        </div>


        {/* 分页器 */}
        {totalRecord > 0 && <div className={styles.paginationTo}>
            <PaginationTo
                current={params.pageNum}
                total={totalRecord}
                pageSize={PAGE_SIZE}
                onChange={(page) => setParams({
                    pageNum: page,
                    pageSize: PAGE_SIZE
                })}
            />
        </div>}

        <Detail 
        mutateList={mutate}
        visible={visible} onClose={function (): void {
            setVisible(false);
        }} father={warpperRef.current}
            currentIndex={currentIndex}
            onClickPrevious={function (): void {
                setCurrentIndex((prev) => {
                    prev = prev - 1;
                    if (prev < 0) {
                        return data?.list?.length - 1
                    }
                    return prev
                })
            }}
            onClickNext={function (): void {
                setCurrentIndex((prev) => {
                    prev = prev + 1;
                    if (prev >= data?.list?.length) {
                        return 0
                    }
                    return prev
                })
            }} list={data?.list} />
    </div>
}


export default MyFeedback